import {
  ANALYTICS_FETCH,
  ANALYTICS_FETCH_FAILURE,
  ANALYTICS_FETCH_SUCCESS,
  ANALYTICS_RESET,
  ANALYTICS_SET,
  ANALTYCS_LOADING,
  ANALTYCS_LOADING_DONE,
  ANALYTICS_INIT_FETCH_SUCCESS,
} from "../actionTypes";

const INITIAL_STATE = {
  analytics: [],
  calls: [],
  companies: {},
  calls_heatmap: null,
  operators: [],
  departments: [],
  available_departments: [],
  loading_analytics: false,
  loading_calls: false,
  loading_companies: false,
  loading_operators: false,
  loading_departments: false,
  loading: false,
  error: null,
};

export default function CallsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ANALYTICS_INIT_FETCH_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        ...payload,
        loading: false,
        error: null,
        loading_analytics: false,
        loading_calls: false,
        loading_companies: false,
        loading_operators: false,
        loading_departments: false,
      };
    }
    case ANALYTICS_FETCH: {
      const { payload } = action;
      return { ...state, [`loading_${payload.type}`]: true, error: null };
    }
    case ANALYTICS_FETCH_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        [payload.type]: payload.data,
        [`loading_${payload.type}`]: false,
        error: null,
      };
    }
    case ANALYTICS_FETCH_FAILURE: {
      const { payload } = action;
      // Clear every in-flight flag, otherwise a failed fetch leaves the
      // dashboard cards spinning forever.
      return {
        ...state,
        loading: false,
        loading_analytics: false,
        loading_calls: false,
        loading_companies: false,
        loading_operators: false,
        loading_departments: false,
        error: payload,
      };
    }
    case ANALTYCS_LOADING:
      return { ...state, loading: true };
    case ANALTYCS_LOADING_DONE:
      return { ...state, loading: false };
    case ANALYTICS_SET: {
      const { payload } = action;
      return { ...state, analytics: payload };
    }
    case ANALYTICS_RESET: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

// case STREAMS_FETCH_SUCCESS: {
//   let stream_type = 'streams'
//   if(action.payload.type !== 'category' && action.payload.type !== 'user_live_stream'){
//     stream_type = `${action.payload.type}_streams`
//   }
//   return {
//     ...state,
//     [stream_type]: [...state[stream_type], ...action.payload.streams],
//     lastDoc: action.payload.lastDoc,
//     loading: false
//   }
// }
